import { Environment } from "./types/environment.type";

export const environment: Environment = {
    apiUrl: "https://api.jobimag.ca",
    sentry: {
        dsn: "https://79f87faef79e20cca8da491541f75c15@o341312.ingest.us.sentry.io/4509039083192321",
        enabled: true,
        environment: "production",
        tracesSampleRate: 1.0,
        tracePropagationTargets: ["https://api.jobimag.ca"],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0
    },
    firebase: {
        apiKey: "AIzaSyCywTjTLfxwhoF8yXBlyIObOT_E2skplyM",
        authDomain: "jobimag-production.firebaseapp.com",
        projectId: "jobimag-production",
        storageBucket: "jobimag-production.firebasestorage.app",
        messagingSenderId: "302644585198",
        appId: "1:302644585198:web:e7fb1bcc706ada8fd389ff",
    },
    language: {
        defaultLang: "fr",
        availableLangs: ["en", "fr"]
    }
};
